<script setup lang="ts">
import { computed } from 'vue';
import { mapStatusToTag, type TransactionTableRow } from '@peanuds/shared';
import { useTranslation } from 'i18next-vue';

const { row } = defineProps<{ row: TransactionTableRow }>();
const { t } = useTranslation();

const statusInfo = computed(() => mapStatusToTag(row));
</script>

<template>
  <Tag :severity="statusInfo.severity" :value="t(statusInfo.value)" />
</template>
